module.exports = __webpack_public_path__ + "img/archive-checked.3e23563d.svg";